<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    disableLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      brand: 'contentful/getBrand',
      content: 'contentful/getContent',
    }),
    logo() {
      return this.brand?.logo?.fields?.file?.url
    },
  },
}
</script>

<template>
  <div :class="$style.navbar">
    <div />
    <BaseLink v-if="!disableLink" :to="{ name: 'home' }">
      <img v-if="logo" :class="$style.logo" :src="logo" />
      <img v-else :class="$style.logo" src="@assets/images/logo.svg" />
    </BaseLink>
    <div v-else>
      <img v-if="logo" :class="$style.logo" :src="logo" />
      <img v-else :class="$style.logo" src="@assets/images/logo.svg" />
    </div>
    <div />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.navbar {
  align-items: center;
  background-color: var(--color-secondary);
  display: flex;
  height: $page-navbar-height;
  justify-content: space-between;
  min-height: $page-navbar-height;
  position: relative;
  z-index: $layer-header-z-index;
}

.logo {
  height: 44px;
}
</style>
